<template>
	<div class="feedback">
		<swiper :options="swiperOption">
			<swiper-slide v-for="(item, index) in data.feedback_slider" :key="index"
			              class="d-flex flex-column justify-content-between align-items-start">
				<a class="stretched-link" :href="item.file.url" target="_blank" download></a>
				<div class="swiper-slide-img d-flex justify-content-center align-items-center">
					<img class="swiper-slide-item" :src="item.img.url" alt="">
				</div>
				<p class="swiper-slide-description">{{item.text}}</p>
			</swiper-slide>
			<div class="control-container d-flex justify-content-start align-items-center"
			     slot="pagination">
				<div class="swiper-pagination swiper-pagination-bullets"></div>
			</div>
		</swiper>
	</div>
</template>

<script>
	const axios = require('axios');
	export default {
		props: {
			typeOfContent: String,
		},
		data() {
			return {
				data: {},
				swiperOption: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 30,
					loop: false,
					breakpoints: {
						768: {
							slidesPerView: 'auto',
							slidesPerGroup: 1,
							spaceBetween: 18,
						}
					},
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
						renderBullet(index, className) {
							return `<span class="${className} swiper-pagination-bullet-custom"></span>`
						}
					}
				}
			}
		},
		created() {
			axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=${this.typeOfContent}`,
				{responseType: 'json'}
			).then(({data}) => {
				this.data = JSON.parse(data.addons);
				if (this.data.visible !== 1) {
					this.$emit('hideup')
				}
			})
			
		},
	}
</script>

<style lang="scss" scoped>
	
	.feedback {
		width: 100%;
		background-color: transparent;
		overflow: hidden;
		
		@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
			margin-right: -15px;
		}
		@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
			.swiper-slide {
				width: 80%;
			}
		}
		
		.ttl {
			font-weight: 500;
			font-size: 44px;
			line-height: 110.1%;
			color: $darkColor;
		}
		
		.swiper-container {
			overflow: visible;
			padding-bottom: 20px;
			
			.swiper-slide {
				height: 183px;
				max-width: 255px;
				background-color: #ffffff;
				border-radius: 6px;
				padding: 20px 26px;
				
				&-img {
					border-radius: 100%;
					transition: all 0.3s ease-in-out;
					height: 70px;
					width: 70px;
					background-color: #EBDADA;
					padding: 14px;
					
					&-item {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
				
				&-description {
					font-weight: 700;
					font-size: 18px;
					line-height: 110.1%;
					color: $mainFontColor;
					transition: all 0.3s ease-in-out;
				}
				
				&:hover {
					.swiper-slide-img {
						filter: drop-shadow(0px 0px 24px #EBDADA);
					}
					
					.swiper-slide-description {
						color: $activeColor;
					}
				}
			}
		}
	}

</style>